<script lang="ts">
	import LineLoader from './LineLoader.svelte'
	import { loadingIndicatorDelay } from './loadingIndicatorDelay'

	interface Props {
		loading?: boolean
		children?: import('svelte').Snippet
	}

	let { loading = $bindable(false), children }: Props = $props()

	setTimeout(() => {
		loading = true
	}, loadingIndicatorDelay)
</script>

{#if loading}
	<LineLoader />
{:else}
	{@render children?.()}
{/if}
